import { SaveStatus } from "../../../../types/SaveStatus";
import { NotebookActionKey } from "../../../actions/ActionKeys";
import { NotebookAction } from "../../../actions/notebook";

export const saveStatus = (
  state: SaveStatus = "saved",
  action: NotebookAction
): SaveStatus => {
  switch (action.type) {
    case NotebookActionKey.SET_IPYNB:
      return "dirty";
    case NotebookActionKey.SET_SAVE_STATUS_SAVED:
      return "saved";
    case NotebookActionKey.SET_SAVE_STATUS_ERROR:
      return "error";
    default:
      return state;
  }
};
